module.exports = __webpack_public_path__ + "static/media/logo-FC-dark_horizontal_consumer3.8fd45cfe.svg";